module.exports = __webpack_public_path__ + "files/e09a760a62bc092e9a4e089bd11e73f2.png";